import React from 'react';
import styled from 'styled-components';
import { Box } from 'grid-styled';
import PropTypes from 'prop-types';
import media from 'styled-media-query';

import Icon from '../Icon/Icon';
import P from '../P/P';

const PageWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: ${props => props.theme.colors.white};

  ${media.greaterThan('small')`
        display:flex;
        align-items:center;
        justify-content: center; 
        background:none;      
    `};
`;

const ContentWrapper = styled.div`
  /* max-width: 450px; */
  /* width: 640px; */
  /* max-width: 60%; */
  width: 100%;
  max-width: 640px;

  background: ${props => props.theme.colors.white};
  padding: 30px;

  @media only screen and (min-width: ${props => props.theme.mq.medium}) {
    min-width: 640px;
    /* width:100%; */
  }
`;

const LogoWrapper = styled.div`
  width: 100%;
  /* display: flex;
  align-items: center;
  justify-content: center; */
`;

class LoginView extends React.Component {
  render() {
    const { title, message } = this.props;
    return (
      <PageWrapper>
        <ContentWrapper pt={'6vh'} pl={10} pr={10} pb={'6vh'}>
          <LogoWrapper>
            <Icon id="ugent" />
          </LogoWrapper>
          <Box pt={'1vh'} mb={'3vh'}>
            <P>{title}</P>
            <P>{message}</P>
          </Box>
          {this.props.children}
        </ContentWrapper>
      </PageWrapper>
    );
  }
}

LoginView.propTypes = {
  messages: PropTypes.string
};

export default LoginView;



// WEBPACK FOOTER //
// ./src/components/LoginView/LoginView.js